export class PaperMergeChild {
    id: number;
    paperId: number;
    partId: number;
    paperMergeId: number;
    mainModelPaperId: number;
    constructor(id: number, paperId: number, partId: number, mainModelPaperId: number, paperMergeId: number) {
        this.id = id;
        this.paperId = paperId;
        this.partId = partId;
        this.mainModelPaperId = mainModelPaperId;
        this.paperMergeId = paperMergeId;
    }

}